export default function (list, col, desc = false) {
    const compare = function (a, b) {
        let number_a = parseFloat(a[col]);
        let number_b = parseFloat(b[col]);
        if (number_a > number_b) return (desc) ? -1 : 1;
        if (number_b > number_a) return (desc) ? 1 : -1;
        return 0;
    };
    return list.sort(compare);
}